// extracted by mini-css-extract-plugin
export default {"language-selector":"language-selector_language-selector__DcCDB","active":"language-selector_active__k4+jv"};